import "./index.scss";
import React from "react";
import cn from "classnames";

interface SearchContentProps {
  children: React.ReactNode;
  isOpen?: boolean;
}

const SearchContent = ({ isOpen, children }: SearchContentProps) => {
  const classSearch = cn("search-overlay", {
    "search-overlay--show": isOpen,
  });
  return <div className={classSearch}>{children}</div>;
};

export default SearchContent;
